import React from 'react';
import theme from './MultiList.module.scss';
import { classnames } from '@/utils/html';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

export type MultiListTableProps = {
    striped?: boolean;
    className?: string;
    columns: any[];
    sortByKey: string;
    setSortByKey: (v: string) => void;
    setSortByAsc: (v: boolean) => void;
    sortByAsc: boolean;
    data: any[];
    onRowClick?: (row: any) => void;
    hideHeaders?: boolean;
};
export const getHeaderKey = (keyName) => {
    if (keyName) return keyName;
    return '__options';
};
const MultiListTable: React.FC<MultiListTableProps> = ({
    striped,
    className,
    columns,
    sortByKey,
    setSortByAsc,
    setSortByKey,
    sortByAsc,
    data,
    onRowClick,
    hideHeaders,
}) => {
    const onHeaderClick = (keyName: string) => {
        if (sortByKey === keyName) {
            return setSortByAsc(!sortByAsc);
        }
        return setSortByKey(keyName);
    };

    const renderRow = (row: any, index: number) => {
        return (
            // onClick={onRowClick ? () => onRowClick(row) : undefined}
            <tr key={index}>
                {columns.map((c, i) => {
                    if (c._type === 'Column')
                        return (
                            <td
                                style={{ width: c.width }}
                                onClick={onRowClick ? () => onRowClick(row) : undefined}
                                key={`${c.keyName}_${i}`}>
                                {c.renderFunction ? c.renderFunction(row[c.keyName], row) : row[c.keyName]}
                            </td>
                        );
                    if (c._type === 'OptionsColumn') {
                        return <td key={`${i}`}>{c.renderFunction && c.renderFunction(row, index)}</td>;
                    }
                    return null;
                })}
            </tr>
        );
    };

    const renderHeaders = () => {
        return columns.map((h, i) => {
            if (h._type === 'Column')
                return (
                    <th
                        style={{ width: h.width }}
                        key={`${h.keyName}_${i}`}
                        className={classnames({ [theme.active]: sortByKey === h.keyName })}
                        onClick={() => onHeaderClick(h.keyName)}>
                        {h.header}{' '}
                        {sortByKey === h.keyName ? (
                            <FontAwesomeIcon icon={sortByAsc ? faCaretUp : faCaretDown} />
                        ) : (
                            // Stop stuff moving around
                            <FontAwesomeIcon style={{ color: 'transparent' }} icon={faCaretUp} />
                        )}
                    </th>
                );
            if (h._type === 'OptionsColumn') {
                const keyName = getHeaderKey(h.keyName);
                const header = h.header ? h.header : <FontAwesomeIcon icon={faExternalLinkAlt} />;
                return (
                    <th className={theme.optionHeader} key={keyName}>
                        {header}
                    </th>
                );
            }
            return null;
        });
    };

    return (
        <table className={classnames(theme.table, { [theme.striped]: striped }, className)}>
            {!hideHeaders && (
                <thead>
                    <tr>{renderHeaders()}</tr>
                </thead>
            )}
            <tbody>{data.map((row, i) => renderRow(row, i))}</tbody>
        </table>
    );
};

export default MultiListTable;
